/* eslint-disable */
import { differenceInCalendarDays } from 'date-fns'
import { isEmpty } from 'lodash'
import {
  all,
  call,
  cancelled,
  delay,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects'
import { IRequestFetch } from '../actions/fetch'
import closeModal from '../actions/Modals/closeModal'
import { signOffFromSession } from '../actions/userAccount/authorize/unauthorize'
import createFetch, { UnauthorizedError } from '../models/fetch'
import { getCalendarId } from '../reducers/bookingCalendar/selectors/calendar'
import getNotificationServiceStore from '../reducers/notificationService/getNotificationServiceStore'
import { SynchronizeActions } from '../reducers/synchronize/actionNames'
import {
  getAccessToken,
  getIsAuthorizing,
} from '../reducers/userAccount/selectors/credentials'
import getUserData from '../reducers/userAccount/selectors/getUserDate'
import i18n from '../i18n'
import { fireToastError } from '../actions/toasts/fireToast'
import { getWorkerId } from '../reducers/userAccount/selectors/userAccount'
import { Mixpanel } from '../utils/Mixpanel'

const requests = []
function getRequestKey({
  url = '',
  method = '',
  responseType = '',
  body = '',
} = {}) {
  return [url, method.toUpperCase(), responseType, body].join('||')
}

function* logoutOnUnauthorized(type, fetch, service) {
  return function*(...args: unknown[]) {
    try {
      const response: Response = yield call(service, ...args)
      return response
    } catch (e) {
      if ('message' in e && e.message === 'Highly unavailable') {
        yield put({ type: SynchronizeActions.FetchConsecutiveErrors })

        return
      } else if ('message' in e && e.message === 'Unauthorized') {
        yield put(closeModal(''))
        yield put({ type: 'Close reservation form modals' })

        let workerId = yield select(getWorkerId)
        if (workerId === undefined) {
          workerId = window.localStorage.getItem('workerId')
        }

        if (workerId && e instanceof UnauthorizedError) {
          Mixpanel.track('Employee Auto Log Out', {
            'Employee ID': workerId,
            'Reason Type': e.reason,
          })
        }

        yield put(signOffFromSession(!workerId))

        if ('routerHistory' in window) {
          window.location.href = '/login'
        }

        return
      }

      throw e
    } finally {
      if (yield cancelled()) {
        fetch.abortController.abort()
      }
    }
  }
}

function* asyncFetch(action: IRequestFetch<unknown>) {
  try {
    const { type, reverseType } = action || {
      reverseType: '',
      type: '',
    }

    const userTime = yield select(getUserData)

    if (Math.abs(differenceInCalendarDays(userTime, new Date())) >= 1) {
      window.location.reload()
    }

    const isAuthorizing = yield select(getIsAuthorizing)
    if (isAuthorizing) {
      yield delay(500)
      yield put(action)
    }

    const notificationService = yield select(getNotificationServiceStore)

    const [accessToken, calendarId] = yield all([
      select(getAccessToken),
      select(getCalendarId),
    ])

    if (isEmpty(accessToken) && isEmpty(notificationService.accessToken)) {
      yield put({
        type: 'User is not authorized and cannot process further',
      })
      return
    }

    const fetch = createFetch(
      notificationService.accessToken
        ? notificationService.accessToken
        : accessToken,
    )
    const service = yield* logoutOnUnauthorized(
      action.type,
      fetch,
      action.cb({ fetch: fetch.authorizedFetch }),
    )
    yield put({ calendarId, service, type: action.reverseType })
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield takeEvery(
    action => !(isEmpty(action.type) || isEmpty(action.reverseType)),
    asyncFetch,
  )
}
